import { useCallback, useMemo, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';

import { createNotification } from '@meiqia/utils';
import { PRIVATIZATION } from '@meiqia/constants';

import {
  setMeConversations,
  setColleaguesConversations,
  setAllConversations,
  setAtMeConversations,
  setHasGotMeConv,
  setHasGotCollConv,
  setHasGotAtMeConv,
  setHasGotAllConv,
  clearConversations,
  addConvs,
  removeConv,
  updateConvMessage,
  updateConvVisitorName,
  addClientTagSocket,
  removeClientTagSocket,
  visitorCome,
  visitorOffline,
  updateConvVisitInfo,
  forcePushColleaguesConversations,
  forcePushMeConversations,
  setUnrecognizedConv,
  setHasGotUnrecognizedConv,
  moveConversationFromColleagueToTrusteeship,
  setAdvertise,
  setAllTalksParams
} from '../../../reducers/conversation';
import { useSelector, useDispatch, useStore } from '../../../react-redux';
import {
  getMeConversationsApi,
  getColleaguesConversationsApi,
  getAtMeConversationsApi,
  getAllConversationsApi,
  getUnrecognizedConversationApi
} from './api';
import { useFunction } from '@meiqia/store';
import { parseUrl } from '@meiqia/utils';
import { C } from 'jssip';

const entId = window.parseInt(Cookies.get('_enterprise_id'));
const emptyObject = {};
const { parseQueryStringObj } = parseUrl;

const nextTo = (news, key) => {
  const pathname = window.location.pathname;
  const { search } = window.location;

  if (pathname === '/chat') {
    const { id, type } = parseQueryStringObj(search);
    if (!news.includes(id) && type === key) {
      window?.im?.emit('toNextConv', { track_id: id });
    }
  }
};

const useConversation = () => {
  const conversation = useSelector(state => state.getIn(['conversationData', 'conv']));
  const nextCursor = useSelector(state => state.getIn(['conversationData', 'nextCursor']));
  const colleaguesHasnext = useSelector(state => state.getIn(['conversationData', 'colleaguesHasnext']));
  const allConvsHasNext = useSelector(state => state.getIn(['conversationData', 'allConvsHasNext']));
  const hasGotMeConv = useSelector(state => state.getIn(['conversationData', 'hasGotMeConv']));
  const hasGotCollConv = useSelector(state => state.getIn(['conversationData', 'hasGotCollConv']));
  const hasGotAtMeConv = useSelector(state => state.getIn(['conversationData', 'hasGotAtMeConv']));
  const hasGotUnrecognizedConv = useSelector(state => state.getIn(['conversationData', 'hasGotUnrecognizedConv']));
  const trusteeshipPermission = useFunction('robot_trusteeship');
  const dispatch = useDispatch();
  const store = useStore().getState();

  // 机器人托管 移动机器人接待的同事对话到“未识别”分组
  function handleColleagueToTrusteeship(msg) {
    dispatch(moveConversationFromColleagueToTrusteeship(msg));
  }

  const pushMeConversationList = useCallback((list = []) => {
    if (list.length) {
      dispatch(forcePushMeConversations({ data: list }));
    }
  }, []);

  const pushColleaguesConversationList = useCallback((list = []) => {
    if (list.length) {
      dispatch(forcePushColleaguesConversations({ data: list }));
    }
  }, []);

  const handleGetAllConvs = useCallback(
    (reconnect = false, options = {}) => {
      const { suppressNotification = false } = options;
      const params = { cursor: reconnect ? -1 : nextCursor, limit: 15, ent_id: entId };
      // 默认每次取，因为有可能取不到
      const agentId = window.parseInt(Cookies.get('_agent_id'));
      const newTrackList = [];
      const basename = PRIVATIZATION.CUSTOMIZED_PATH;

      getMeConversationsApi()
        .then(res => {
          const newConvList = res.data || [];
          // res: {data: Conv[]}
          // 临时做法，我的对话中剔除预托管对话，下期需求会重做接口
          const meConvs = newConvList.filter(conv => conv.trusted !== 2);
          const preTrusteeshipConvs = newConvList.filter(conv => conv.trusted === 2);
          const oldConv = store.getIn(['conversationData', 'conv']) || [];
          // 如果是重连
          if (reconnect && !suppressNotification) {
            const notificationList = [];
            if (!oldConv.length) {
              newConvList.forEach(item => {
                const { name } = item.visit_info;
                notificationList.push({
                  title: '新对话：',
                  body: `${name}进入对话`,
                  trackId: item.track_id
                });
              });
            }
            // 如果新来的对话大于老的，添加推送队列
            else {
              const oldTrackList = oldConv.map(conv => conv.track_id);
              const diffOneList = [];

              // 找到第一个trackid不在旧列表里面的数据
              newConvList.forEach(item => {
                newTrackList.push(item.track_id);
                if (!oldTrackList.includes(item.track_id)) {
                  diffOneList.push(item);
                }
                oldConv.forEach(oldConvItem => {
                  if (item.track_id === oldConvItem.track_id && item.client_msg_num > oldConvItem.client_msg_num) {
                    notificationList.push({
                      title: '您有消息未回复：',
                      body: item.last_msg_content,
                      trackId: item.track_id
                    });
                  }
                });
              });

              if (diffOneList.length) {
                diffOneList.forEach(diffOne => {
                  const { name } = diffOne.visit_info;
                  notificationList.push({
                    title: '新对话：',
                    body: `${name}进入对话`,
                    trackId: diffOne.track_id
                  });
                });
              }
            }

            if (notificationList.length) {
              notificationList.forEach((notification, index) => {
                setTimeout(() => {
                  createNotification({
                    ...notification,
                    onclick: () => {
                      window.location.href = `${basename}/chat?id=${notification.trackId}&convType=mine`;
                    }
                  });
                }, index * 1000);
              });
            }
          }
          dispatch(setMeConversations({ data: meConvs }));
          window?.im?.emit('handleTimeout', meConvs);
          dispatch(setColleaguesConversations({ data: preTrusteeshipConvs, isTrusteeship: true }));
          //处理ws断线之后对话不移除
          if (reconnect) {
            nextTo(newTrackList, 'mine');
          }
        })
        .finally(() => {
          dispatch(setHasGotMeConv(true));
        });
      getColleaguesConversationsApi(params)
        .then(res => {
          dispatch(setColleaguesConversations({ ...res, reconnect }));
          window?.im?.emit('handleTimeout', res.data);

          if (reconnect) {
            nextTo(res?.data?.map(x => x.track_id) || [], 'coll');
          }
        })
        .finally(() => {
          dispatch(setHasGotCollConv(true));
        });

      getAtMeConversationsApi(agentId)
        .then(res => {
          dispatch(setAtMeConversations(res));
          if (reconnect) {
            nextTo(res?.data?.map(x => x.track_id) || [], 'mention');
          }
        })
        .finally(() => {
          dispatch(setHasGotAtMeConv(true));
        });
      getAllConversationsApi(params)
        .then(res => {
          dispatch(setAllConversations({ ...res, reconnect }));
        })
        .finally(() => {
          dispatch(setHasGotAllConv(true));
        });
    },
    [nextCursor, store]
  );
  const handleGetAllTalks = useCallback(
    (cover, rules, offset_token = '') => {
      const params = { rules, ent_id: entId };
      if (offset_token) {
        params.offset_token = offset_token;
      }
      return getAllConversationsApi(params)
        .then(res => {
          dispatch(setAllConversations({ ...res, coverData: cover }));
        })
        .finally(() => {
          dispatch(setHasGotAllConv(true));
        });
    },
    [nextCursor, store]
  );

  const handleSetAllTalksParams = rules => {
    dispatch(setAllTalksParams(rules));
  };

  // 情况说明：
  // unrecognizedConv是未识别会话，这个接口在来鼓没有，因为前端接口底层接入了antd的message
  // 请求此接口会提示404报错，所以选择当有robot_trusteeship时才请求
  // 又因为权限是通过api拿的，所以应用最开始一定没有权限，并会拉取其他会话并标记已拉取
  // 此时权限接口返回，用户若正好有权限的话
  // 未识别会话将不会被初始化（因为没监听权限变化，并且初始化操作不能监听初始化函数变动【线上bug循环请求】）
  // 此时返回的是否已拉取所有会话（handleGetAllConvs）也将为false， 影响后续的会话状态拉取
  // 所以临时将未识别会话的拉取放到hooks内部处理

  // useconversation多处使用，避免重复请求，用ref判断一下是否请求中
  // const unrecognizedConvAPIPromiseRef = useRef(null);
  // useEffect(() => {
  //   // 默认每次取，因为有可能取不到
  //   const agentId = window.parseInt(Cookies.get('_agent_id'));
  //   if (trusteeshipPermission && !hasGotUnrecognizedConv && !unrecognizedConvAPIPromiseRef.current) {
  //     unrecognizedConvAPIPromiseRef.current = getUnrecognizedConversationApi(agentId)
  //       .then(res => dispatch(setUnrecognizedConv(res)))
  //       .finally(() => {
  //         dispatch(setHasGotUnrecognizedConv(true));
  //         unrecognizedConvAPIPromiseRef.current = null;
  //       });
  //   }
  // }, [trusteeshipPermission, hasGotUnrecognizedConv]);

  const onReconnectSocket = useCallback(
    (options = {}) => {
      //重连之后把请求同事列表的netCursor还原
      dispatch(setHasGotMeConv(false));
      dispatch(setHasGotCollConv(false));
      dispatch(setHasGotAtMeConv(false));
      if (trusteeshipPermission) {
        dispatch(setHasGotUnrecognizedConv(false));
      }
      handleGetAllConvs(true, options);
    },
    [handleGetAllConvs, trusteeshipPermission]
  );

  const handleGetMoreColl = useCallback(() => {
    const params = { cursor: nextCursor, limit: 15, ent_id: entId };
    return getColleaguesConversationsApi(params).then(res => {
      dispatch(setColleaguesConversations(res));
      return res;
    });
  }, [nextCursor]);

  const handleGetSearchColl = useCallback(() => {
    const params = { cursor: -1, limit: 15, ent_id: entId };
    return getColleaguesConversationsApi(params).then(res => {
      dispatch(setColleaguesConversations({ ...res, reconnect: true }));
      return res;
    });
  }, []);

  const hasGotAllConvs = useMemo(() => {
    const allConvs = [hasGotMeConv, hasGotCollConv, hasGotAtMeConv];

    // if (trusteeshipPermission) {
    //   allConvs.push(hasGotUnrecognizedConv);
    // }
    return allConvs.every(val => val);
  }, [hasGotMeConv, hasGotCollConv, hasGotAtMeConv, trusteeshipPermission]);

  const extraAction = useMemo(() => {
    const actionKeyName = [
      'clearConversations',
      'addConvs',
      'removeConv',
      'updateConvMessage',
      'updateConvVisitorName',
      'addClientTagSocket',
      'removeClientTagSocket',
      'visitorCome',
      'visitorOffline',
      'updateConvVisitInfo',
      'setAdvertise'
    ];
    return [
      clearConversations,
      addConvs,
      removeConv,
      updateConvMessage,
      updateConvVisitorName,
      addClientTagSocket,
      removeClientTagSocket,
      visitorCome,
      visitorOffline,
      updateConvVisitInfo,
      setAdvertise
    ].reduce((prev, now, index) => {
      return {
        ...prev,
        [actionKeyName[index]]: param => dispatch(now(param))
      };
    }, {});
  }, [dispatch]);

  const getConversationById = useCallback(
    id => {
      return conversation.find(c => c.track_id === id) || emptyObject;
    },
    [conversation]
  );

  return {
    conversation,
    nextCursor,
    colleaguesHasnext,
    allConvsHasNext,
    hasGotAllConvs,
    handleGetMoreColl,
    handleGetAllConvs,
    handleGetAllTalks,
    handleSetAllTalksParams,
    getConversationById,
    onReconnectSocket,
    pushMeConversationList,
    pushColleaguesConversationList,
    handleColleagueToTrusteeship,
    handleGetSearchColl,
    ...extraAction
  };
};

export default useConversation;
